import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { GiPartyPopper } from "react-icons/gi";
import { FaMapPin } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import axiosNew from "../store/api/axiosNew";


export default function NotificationPopup({ show, handleClose, lead }) {

    const isMobile = useMediaQuery({ maxWidth: 576 })

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title><GiPartyPopper style={{ color: "#ff4d4f", fontSize: isMobile ? "18px" : "24px" }} />{" "}New Lead Alert</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: isMobile ? "left" : "center", padding: isMobile ? "8px" : "10px" }}>
                    <h5 style={{ fontWeight: "600", color: "#026195", fontSize: isMobile ? "16px" : "20px" }}>{lead?.leadId?.name || "Unknown Lead"}</h5>
                    <p style={{ fontSize: isMobile ? "12px" : "14px", color: "#555", fontWeight: "500" }}><FaMapPin style={{ color: "#051218", fontSize: isMobile ? "16px" : "20px" }} />{" "}{lead?.leadId?.location || lead?.logId?.location || "Location not available"}</p>
                    <p style={{ fontSize: isMobile ? "10px" : "12px", color: "#888" }}>{lead?.message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose} style={{ width: isMobile ? "100%" : "auto" }}>Got it</Button>
            </Modal.Footer>
        </Modal>
    )
}